import { Poppins } from 'src/common';
import { DangerTooltip } from './DangerTooltip';
import { getCurrencySymbol } from 'src/utils/misc';
import { AssessmentState } from '../types';
import React from 'react';

interface CashPlaceholderProps {
  state: AssessmentState;
}

export const CashPlaceholder: React.FC<CashPlaceholderProps> = ({ state }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        flex: 1,
        marginRight: 'auto',
        maxHeight: 20,
      }}
    >
      <Poppins weight={600} px={26}>
        {getCurrencySymbol()}
      </Poppins>
      <div style={{ marginBottom: 2 }}>
        <DangerTooltip state={state} />
      </div>
    </div>
  );
};
